/**
 * @file 産業廃棄物ページのご依頼いただけるもの部分「詳しく見るボタン」トグル動作
 *
 */
'use strict';

/**
 * @classname OpenHandleableWasteDetailIndustrialView
 * @classdesc 産業廃棄物ページのご依頼いただけるもの部分「詳しく見るボタン」トグル動作
 */
export default class OpenHandleableWasteDetailIndustrialView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('OpenHandleableWasteDetailIndustrialView.constructor');
		this._$e = $e;
		this._$target = this._$e.closest('li');
		this._$e.on('click', () => this.onClick());
	}

	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof OpenHandleableWasteDetailIndustrialView
	 * @return {undefined}
	 */
	onClick() {
		console.log('OpenHandleableWasteDetailIndustrialView.onClick');
		this._$target.toggleClass('is-open');
	}
}
